import React, { Fragment } from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import Select from 'react-select';
import ColorPicker from '../../../Components/ColorPicker';
import LabelColorSlider from '../../../Components/LabelColorSlider';
import { normalizePeriodColumnPeriod } from '../../../utils/periodColumnWidget';

const PeriodColumnWidgetSettings = ({
	edit,
	setEdit,
	t,
	periodOptions,
	periodStats,
	selectedDatastream,
	getDsMinMax,
	themeColorKey,
	themeColorValue,
}) => (
	<Fragment>
		<div className='form-item'>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
				{t.settingsLabels?.period || 'Period'}
			</label>
			<Select
				classNamePrefix="react-select"
				options={periodOptions.map(option => ({ label: option.label, value: option.value }))}
				value={periodOptions.map(option => ({ label: option.label, value: option.value })).find(option => option.value === normalizePeriodColumnPeriod(edit.props.period))}
				onChange={selectedOption => setEdit(prev => ({
					...prev,
					props: {
						...prev.props,
						period: selectedOption ? selectedOption.value : 'day'
					}
				}))}
				isClearable={false}
			/>
		</div>

		<div className='form-item'>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
				{t.settingsLabels?.stat || 'Value to Display'}
			</label>
			<Select
				classNamePrefix="react-select"
				options={periodStats.map(option => ({ label: option.label, value: option.value }))}
				value={periodStats.map(option => ({ label: option.label, value: option.value })).find(option => option.value === edit.props.stat)}
				onChange={selectedOption => setEdit(prev => ({
					...prev,
					props: {
						...prev.props,
						stat: selectedOption ? selectedOption.value : 'max'
					}
				}))}
				isClearable={false}
			/>
		</div>

		<div className='form-item'>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
				{t.settingsLabels?.showUnit || 'Show Unit'}
			</label>
			{edit.props.showUnit !== false ? (
				<ToggleOn
					style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
					onClick={() => setEdit(prev => ({
						...prev,
						props: { ...prev.props, showUnit: false }
					}))}
				/>
			) : (
				<ToggleOff
					style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
					onClick={() => setEdit(prev => ({
						...prev,
						props: { ...prev.props, showUnit: true }
					}))}
				/>
			)}
		</div>

		<div className='form-item'>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
				{t.settingsLabels?.changeColorBasedOnValue || 'Change Color Based On Value'}
			</label>
			{edit.props.changeColorBasedOnValue ? (
				<ToggleOn
					style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
					onClick={() => setEdit(prev => ({
						...prev,
						props: { ...prev.props, changeColorBasedOnValue: false }
					}))}
				/>
			) : (
				<ToggleOff
					style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
					onClick={() => setEdit(prev => ({
						...prev,
						props: { ...prev.props, changeColorBasedOnValue: true }
					}))}
				/>
			)}
		</div>

		{edit.props.changeColorBasedOnValue ? (
			<Fragment>
				<div className='form-item'>
					<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
						{t.settingsLabels?.colorGrading || 'Color Grading'}
					</label>
					{edit.props.colorGrading ? (
						<ToggleOn
							style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
							onClick={() => setEdit(prev => ({
								...prev,
								props: { ...prev.props, colorGrading: false }
							}))}
						/>
					) : (
						<ToggleOff
							style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
							onClick={() => setEdit(prev => ({
								...prev,
								props: { ...prev.props, colorGrading: true }
							}))}
						/>
					)}
				</div>

				<LabelColorSlider
					minValue={getDsMinMax(selectedDatastream).min ?? 0}
					maxValue={getDsMinMax(selectedDatastream).max ?? 100}
					stops={themeColorValue(edit.props, 'colors', [])}
					colorGrading={Boolean(edit.props.colorGrading)}
					setStops={(updated) => setEdit(prev => ({
						...prev,
						props: { ...prev.props, [themeColorKey('colors')]: updated }
					}))}
				/>
			</Fragment>
		) : (
			<div className='form-item'>
				<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
					{t.settingsLabels?.color || 'Color'}
				</label>
				<ColorPicker
					id="period-column-color"
					color={themeColorValue(edit.props, 'color', '#3b82f6')}
					setColor={(c) => setEdit(prev => ({
						...prev,
						props: { ...prev.props, [themeColorKey('color')]: c }
					}))}
				/>
			</div>
		)}
	</Fragment>
);

export default PeriodColumnWidgetSettings;
